import { apiSlice } from './apiSlice';

/**
 * Certificates.
 *
 *   GET   /v3/achievements/certificates/list/ → paginated { count, next,
 *                                               previous, page_number,
 *                                               page_size, results[] }
 *   GET   /certificate/<id>/                  → the shared view, no session
 *   PUT   /certificate/<id>/                  ← multipart: public
 */
export const certificatesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCertificates: builder.query({
      query: (params) => ({
        url: '/v3/achievements/certificates/list/',
        params: { page_size: 10, ...params },
      }),
      providesTags: ['Certificate'],
    }),

    /** The shared view. No session — the link goes to anyone — and the
     *  endpoint answers 200 with `{ error }` when sharing is off. */
    getSharedCertificate: builder.query({
      query: (id) => `/certificate/${id}/`,
    }),

    /** Takes the multipart FormData the page builds, like the KYC upload. */
    updateCertificate: builder.mutation({
      query: ({ id, body }) => ({
        url: `/certificate/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Certificate'],
    }),
  }),
});

export const {
  useGetCertificatesQuery,
  useGetSharedCertificateQuery,
  useUpdateCertificateMutation,
} = certificatesApi;
